import * as moment from "moment/moment";
import {Role} from "../account/AccountProvider";

export const isEventDateDisabled = (role: Role, date: moment.Moment): boolean => {
  if (role === Role.ADMIN) {
    return false;
  }

  const now = moment();
  const startOfPreviousWeek = now.startOf('week').subtract(2, 'weeks');
  return date.isBefore(startOfPreviousWeek);
}



// WEBPACK FOOTER //
// ./src/event-details/event-utils.ts